<template>
  <h1>This page will be updated soon</h1>
</template>

<script>
export default {};
</script>

<style></style>
